<app-header [pendinginvitationlist]="pendinginvitationlist"></app-header>
<app-leftsidebar [activePath]="activePath"></app-leftsidebar>

<div class="agm-main">
  <div class="right-sec">
    <div class="agm-wrap">

      <div class="agm-head">
        <div class="agm-head-text">
          <h1>Active <span class="gold">games</span></h1>
          <p>
            Tables you're running. Start a game on any world, seat your players,
            upload a party token, and jump in when it's time.
          </p>
        </div>
        <div class="agm-head-actions">
          <a class="btn btn-outline" routerLink="/maplist" [queryParams]="{ game: true }">Maps</a>
          <ng-container *ngxPermissionsExcept="['ADVENTURER']">
            <button class="btn btn-theme" (click)="newgame()" *ngIf="!shouldShowGameLimitReached()">
              New game
            </button>
          </ng-container>
        </div>
      </div>

      <div class="agm-toolbar">
        <div class="agm-tabs" role="tablist">
          <button role="tab" [attr.aria-selected]="selectedTab === 'active'" (click)="selectedTab = 'active'">
            Active <span class="agm-count">{{ (gamelistdata || []).length }}</span>
          </button>
          <button role="tab" [attr.aria-selected]="selectedTab === 'paused'" (click)="selectedTab = 'paused'">
            Paused <span class="agm-count">0</span>
          </button>
          <button role="tab" [attr.aria-selected]="selectedTab === 'completed'" (click)="selectedTab = 'completed'">
            Completed <span class="agm-count">0</span>
          </button>
        </div>
        <div class="agm-view-toggle" role="group" aria-label="View" *ngIf="!isMobile">
          <button [attr.aria-pressed]="viewMode === 'cards'" (click)="setViewMode('cards')">Cards</button>
          <button [attr.aria-pressed]="viewMode === 'rows'" (click)="setViewMode('rows')">Rows</button>
        </div>
      </div>

      <p class="agm-help" [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'active'">Active tables are ready to run — seat your players, upload a party token and jump in.</ng-container>
        <ng-container *ngSwitchCase="'paused'">Paused tables keep their map, party and journal, but can't be played until you resume them.</ng-container>
        <ng-container *ngSwitchDefault>Completed tables are read-only — the map, party and journal remain for reference.</ng-container>
      </p>

      <div class="agm-grid" [class.is-rows]="viewMode === 'rows'">
        <article class="agm-card" *ngFor="let item of gamesForTab" [attr.data-status]="gameStatus(item)">
          <div class="agm-card-top">
            <button type="button" class="agm-thumb" (click)="uploadFile(item)" aria-label="Change party token">
              <img [src]="item.partytoken ? imageurl + item.partytoken : 'assets/images/ac-token-game.png'" alt="" />
              <span class="agm-sys" *ngIf="item.game_system">{{ item.game_system }}</span>
            </button>

            <div class="agm-card-id">
              <span class="agm-pill" [attr.data-status]="gameStatus(item)">{{ gameStatusLabel(item) }}</span>
              <h3 class="agm-name" (click)="gotogamedetail(item.id)">{{ item.Gamename || 'Untitled game' }}</h3>
              <p class="agm-meta">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M6 21V4M6 4l9 3-3 4 6 2-12 4" />
                </svg>
                {{ item.map_name || 'No map yet' }} · Party lvl {{ item.partylevel || '—' }}
                <ng-container *ngIf="item.Averagelevel"> · avg {{ item.Averagelevel }}</ng-container>
              </p>
            </div>
          </div>

          <div class="agm-party">
            <span class="agm-avatars">
              <span class="agm-avatar" *ngFor="let c of filledSeats(item).slice(0, 4)">{{ initials(c) }}</span>
              <span class="agm-avatar agm-avatar--open" *ngIf="openSeats(item) > 0">+{{ openSeats(item) }}</span>
            </span>
            <span class="agm-party-names">{{ partyNames(item) }}</span>
          </div>

          <div class="agm-actions">
            <button class="btn btn-green" [disabled]="item?.map_id === undefined" (click)="playgame(item)">
              Play
            </button>
            <button class="btn btn-outline" (click)="gotogamedetail(item.id)">Details</button>
          </div>
        </article>

        <ng-container *ngIf="selectedTab === 'active'">
          <button *ngIf="!shouldShowGameLimitReached(); else gameLimitReached" class="agm-add" (click)="newgame()">
            <span class="agm-add-plus">+</span>
            <span class="agm-add-label">New game</span>
            <span class="agm-add-sub">Pick a world, name the table, seat your players.</span>
          </button>
          <ng-template #gameLimitReached>
            <div class="agm-limit">
              <span>You've reached your game creation limit. Subscribe to run more tables.</span>
              <button class="btn btn-green" [routerLink]="['/subscription']" [queryParams]="{ isUser: true }">
                Subscribe
              </button>
            </div>
          </ng-template>
        </ng-container>

        <p class="agm-empty" *ngIf="gamesForTab.length === 0 && selectedTab !== 'active'">
          No {{ selectedTab }} games.
        </p>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
